import * as types from '../mutation-types'
import router from '../../router'
import assign from 'lodash/assign'
import uniq from 'lodash/uniq'
import includes from 'lodash/includes'
import pick from 'lodash/pick'
import has from 'lodash/has'
import keys from 'lodash/keys'
import mapKeys from 'lodash/mapKeys'
import defaults from 'lodash/defaults'
import uuid from 'uuid/v4'
import Vue from 'vue'

const createTreeFromStep = function (initialStep) {
  let tree = { initialStep }
  let parentId = null;
  (function recurse (currentStep) {
    if (currentStep.type === 'SimpleAction') {
      assign(currentStep, {
        hangup: {
          type: 'Hangup',
          title: 'Hangup'
        },
        begin: {
          type: 'Begin',
          title: 'Begin'
        },
        return: {
          type: 'Return',
          title: 'Return'
        },
        repeat: {
          type: 'Repeat',
          title: 'Repeat'
        }
      }[currentStep.action])
    }

    currentStep.id = uuid()
    currentStep.parentId = parentId
    parentId = currentStep.id
    defaults(currentStep, { input: null, step: null })

    if (currentStep.step) {
      recurse(currentStep.step)
    } else if (currentStep.input) {
      currentStep.input.choices.map(item => recurse(item.step))
    } else {
    }
    return currentStep
  })(initialStep)

  return tree
}

const traverse = function (tree, callback) {
  (function recurse (currentStep) {
    if (currentStep.step) {
      recurse(currentStep.step)
    } else if (currentStep.input) {
      currentStep.input.choices.map(item => recurse(item.step))
    }
    callback(currentStep)
  })(tree.initialStep)
}

const updateTree = function (tree, data) {
  if (tree) {
    traverse(tree, function (step) {
      if (step.id === data.id) {
        mapKeys(step, (value, key) => {
          if (!has(data, key)) delete step[key]
        })
        assign(step, data)
      }
    })
  }
  Vue.set(state, 'tree', tree)
}

const state = {
  tree: null,
  currentStep: null
}

const getters = {
  tree (state) {
    return state.tree
  },
  currentStep (state) {
    return state.currentStep
  },
  step (state, getters) {
    if (getters.currentStep) return state.currentStep.step
  },
  input (state, getters) {
    if (getters.currentStep) return state.currentStep.input
  },
  stepById (state) {
    return function (id) {
      let res
      traverse(state.tree, function (step) {
        if (step.id === id) return (res = step)
      })
      return res
    }
  },
  genStepTitle (state) {
    return function (step) {
      // let title = step.title
      // if (state.tree && isEmpty(title)) {
      //   let types = []
      //   traverse(state.tree, function (step) {
      //     types.push(step.type)
      //   })
      //   const count = countBy(types)[step.type]
      //   title = `${step.type} ${count || '1'}`
      // }
      return step.title
    }
  },
  breadCrumbs (state, getters) {
    let array = []
    if (state.tree && state.currentStep) {
      array.push(state.currentStep)
      let parentId = state.currentStep.parentId
      while (parentId) {
        const step = getters.stepById(parentId)
        array.unshift(step)
        parentId = step.parentId
      }
    }
    return array
  },
  isSimpleAction (state, getters) {
    return function () {
      return includes(['Hangup', 'Begin', 'Return', 'Repeat'], getters.step.type)
    }
  }
}

const actions = {
  navigate ({ commit, getters }, { id, campaignId }) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const data = getters.stepById(id)
        router.push({ path: `/admin/campaigns/${campaignId || ''}${campaignId ? '/edit' : 'new'}/${id}` })
        commit(types.SET_DIALPLAN_CURRENT_STEP, { data })
        resolve(data)
      })
    })
  },
  initDialplan ({ commit, state, getters }) {
    commit(types.SET_DIALPLAN_FROM_STEP, { step: getters.initialStep })
  },
  setCurrentStepObject ({ commit, state }, object) {
    const props = uniq(keys(object).concat(['id', 'parentId', 'step', 'input', 'type']))
    const data = assign(object, pick(state.currentStep, props))
    commit(types.SET_DIALPLAN_CURRENT_STEP, { data })
  }
}

const mutations = {
  [types.SET_DIALPLAN_FROM_STEP] (state, { step }) {
    state.tree = createTreeFromStep(step)
    state.currentStep = state.tree.initialStep
  },

  [types.SET_DIALPLAN_CURRENT_STEP] (state, { data }) {
    if (!data.id) data.id = uuid()
    state.currentStep = data
    updateTree(state.tree, state.currentStep)
  },

  [types.SET_DIALPLAN_NEXT_STEP] (state, { step }) {
    if (state.currentStep) {
      if (!step.id) {
        step.id = uuid()
        step.parentId = state.currentStep.id
      }
      step.step = step.step
      step.input = step.input
      state.currentStep.step = step
      updateTree(state.tree, state.currentStep)
    }
  },

  [types.SET_DIALPLAN_INPUT] (state, { input }) {
    if (state.currentStep) {
      state.currentStep.input = input
      updateTree(state.tree, state.currentStep)
    }
  },

  [types.RESET_DIALPLAN_STATE] (state) {
    state = {
      tree: null,
      currentStep: null
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dialplan.js